import React from 'react'

export default React.memo(
	({headerText, children}) => (
		<div className='map-expanded-menu-header big-bold-header-text no-bottom'>
			<div>{headerText}</div>
			{children}
		</div>
	)
)
